module.exports = __webpack_public_path__ + "static/images/styles/images/battlerooms_bg.6694bade.jpg";


//////////////////
// WEBPACK FOOTER
// ./styles/images/battlerooms_bg.jpg
// module id = 3492
// module chunks = 11